export function registerVideoPlayer(Alpine) {
    Alpine.data('videoPlayer', () => ({
        playing: false,
        progress: 0,
        currentTime: '0:00',
        duration: '0:00',
        _video: null,
        _raf: null,

        init() {
            this._video = this.$el.querySelector('video');
            if (!this._video) return;

            // Nascondi controlli nativi
            this._video.removeAttribute('controls');

            this._video.addEventListener('loadedmetadata', () => {
                this.duration = this._fmt(this._video.duration);
            });

            this._video.addEventListener('ended', () => {
                this.playing = false;
                this.progress = 100;
                cancelAnimationFrame(this._raf);
            });
        },

        togglePlay() {
            if (!this._video) return;
            if (this._video.paused) {
                this._video.play();
                this.playing = true;
                this._tick();
            } else {
                this._video.pause();
                this.playing = false;
                cancelAnimationFrame(this._raf);
            }
        },

        toggleFullscreen() {
            if (!this._video) return;
            if (document.fullscreenElement) {
                document.exitFullscreen();
            } else if (this._video.requestFullscreen) {
                this._video.requestFullscreen();
            } else if (this._video.webkitEnterFullscreen) {
                // Safari iOS
                this._video.webkitEnterFullscreen();
            }
        },

        seek(e) {
            if (!this._video || !this._video.duration) return;
            const bar = e.currentTarget;
            const rect = bar.getBoundingClientRect();
            const pct = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
            this._video.currentTime = pct * this._video.duration;
            this.progress = pct * 100;
            this.currentTime = this._fmt(this._video.currentTime);
        },

        _tick() {
            if (!this._video || this._video.paused) return;
            this.progress = (this._video.currentTime / this._video.duration) * 100 || 0;
            this.currentTime = this._fmt(this._video.currentTime);
            this._raf = requestAnimationFrame(() => this._tick());
        },

        _fmt(s) {
            const m = Math.floor(s / 60);
            const sec = Math.floor(s % 60);
            return m + ':' + String(sec).padStart(2, '0');
        },
    }));
}
